import React, { useState } from "react";
import { Box, Button, Typography, Select, MenuItem } from "@mui/material";
import {
  DataGrid,
  GridRowModes,
  GridActionsCellItem,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import {
  Add as AddIcon,
  MarkChatRead as ReplyIcon,
  CheckCircle as ResolveIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const boxStyles = {
  p: 3,
  height: "auto",
  width: "100%",
  "& .headerTheme": {
    backgroundColor: "#F2F2F2",
    fontSize: "14px",
    fontWeight: "400",
  },
};

const ReusableDataGrid = ({ data }) => {
  const navigate = useNavigate();
  console.log(data);
  const [rows, setRows] = useState(data || []);
  const [rowModesModel, setRowModesModel] = useState({});

  // Action Handlers
  const handleReplyClick = (id) => {
    // alert(`Replying to Ticket ID: ${id}`);
    //push to ticket detail page using router
    navigate(`/ticket/${id}`);
  };

  const handleResolveClick = (id) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id
          ? { ...row, status: "Resolved", updatedAt: new Date().toLocaleDateString() }
          : row
      )
    );
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  // Column Configuration
  const columns = [
    { field: "ticketId", headerName: "Ticket ID", flex: 1 },
    { field: "subject", headerName: "Subject", flex: 1.5, editable: true },
    { field: "category", headerName: "Category", flex: 1, editable: true },
    { field: "priority", headerName: "Priority", flex: 1, editable: true },
    { field: "createdAt", headerName: "Created At", flex: 1 },
    { field: "updatedAt", headerName: "Updated At", flex: 1 },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => (
        <Typography color={params.value === "Open" ? "error" : "success"}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      flex: 1.5,
      getActions: ({ id }) => [
        <GridActionsCellItem
          icon={<ReplyIcon />}
          label="Reply"
          onClick={() => handleReplyClick(id)}
          color="primary"
        />,
        <GridActionsCellItem
          icon={<ResolveIcon />}
          label="Mark as Resolved"
          onClick={() => handleResolveClick(id)}
          color="success"
        />,
      ],
    },
  ];

  return (
    <Box sx={boxStyles}>
      <DataGrid
        rows={data}
        columns={columns}
        autoHeight
        editMode="row"
        rowModesModel={rowModesModel}
        onRowModesModelChange={setRowModesModel}
        processRowUpdate={processRowUpdate}
      />
    </Box>
  );
};

export default ReusableDataGrid;